import theme from "@/styles/theme";
import styled from "styled-components";

export const Container = styled.div`
  border-style: solid;
  border-width: 1px;
  border-color: ${theme.colors.palete.gold};
  border-radius: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 80%;
  width: 80%;
  margin-inline: 3vw;
  .main-label {
    font-family: sans-serif;
    font-weight: 800;
    color: white;
    font-size: ${theme.fontSize.lg};
    align-self: center;
    margin-top: 10vh;
    @media ${theme.devices.tablet} {
      margin-top: 5vh;
      font-size: ${theme.fontSize.md};
      text-align: -webkit-center;
    }
  }
`;

export const HeaderCredits = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  width: 100%;
  text-align: center;
  color: white;
  margin-bottom: 30px;
  h1 {
    font-family: sans-serif;
    font-weight: 700;
    font-size: ${theme.fontSize.lg};
    margin-bottom: 5px;
  }

  h2 {
    font-family: sans-serif;
    font-weight: 600;
    font-size: ${theme.fontSize.md2};
    margin-bottom: 5px;
  }
`;

export const CardsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  place-content: center;
  @media ${theme.devices.tablet} {
    flex-direction: column;
    margin-top: 0vh;
    align-items: center;
    row-gap: 0vh;
  }
`;

export const FormPixType = styled.form`
  display: flex;
  padding: 30px;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  border-radius: 10px;

  div {
    width: 100%;
  }
`;
